/** @format */

import React, { useEffect, useState, Suspense, lazy } from 'react';
import Cookies from 'js-cookie';
import {
	BrowserRouter,
	Routes,
	Route,
	Navigate,
	useSearchParams,
} from 'react-router-dom';

import { NProvider } from './Elements/Navbar/NavbarContext';
import Layout from './helper/Layout';
import useAuth from './hooks/useAuth';
import AuthContext from './Context/AuthContext';
import ProtectedRoutes from './Context/ProtectRoutes';
import FallbackLoading from './Elements/Misc/FallbackLoading';

const DashBoard = lazy(() => import('./screens/DashBoard/DashBoard'));
const FilterContext = lazy(() =>
	import('./Context/FilterContext/FilterContext')
);

const LoginScreen = lazy(() => import('./screens/Auth/Login'));
const SignUpScreen = lazy(() => import('./screens/Auth/Singup'));
const Verify = lazy(() => import('./screens/Auth/Verify'));
const TermsConditions = lazy(() => import('./screens/Auth/Terms'));
const TeamSignUp = lazy(() => import('./screens/Auth/TeamSignup'));
const ForgotPassword = lazy(() => import('./screens/Auth/ForgotPassword'));
const ResetPassword = lazy(() => import('./screens/Auth/ResetPassword'));
const PlansScreen = lazy(() => import('./screens/Plans/Plans'));
const APIScreen = lazy(() => import('./screens/API/APIScreen'));
const DataSearch = lazy(() => import('./screens/Datasearch/datasearch'));
const IntegrationScreen = lazy(() =>
	import('./screens/Integrations/Integrations')
);
const AppLayout = lazy(() => import('./screens/AppLayout'));
// const MyLists = lazy(() => import( './screens/Lists/MyLists'));
// const ContactSearch = lazy(() => import( './screens/ContactSearch/ContactSearch'));
const BillingScreen = lazy(() => import('./screens/Billing/Billing'));
const MyTools = lazy(() => import('./screens/Tools/Tools'));
const Profile = lazy(() => import('./screens/Profile/Profile'));
const FailedScreen = lazy(() => import('./screens/Misc/Failed'));
const SuccessScreen = lazy(() => import('./screens/Misc/Success'));
const LinkScreen = lazy(() => import('./screens/Misc/LinkIssues'));
const ScreenSizeAlert = lazy(() => import('./screens/Misc/ScreenSizeAlert'));
const Datasets = lazy(() => import('./screens/Datasets/Datasets'));
const NotFound = lazy(() => import('./screens/Misc/NotFound'));

const UserNavigate = () => {
	const [searchParams] = useSearchParams();
	const planId = searchParams.get('planId') || '';
	const type = searchParams.get('type') || '';
	const token = Cookies.get('token');
	useEffect(() => {
		if (type && planId && token?.length > 20) {
			window.location =
				'/thankyou?planId=' +
				planId +
				`&isAnnual=${type === 'year' ? 'true' : 'false'}` +
				'&token=' +
				token;
		}
	}, []);
	return <></>;
};

const AllRoutes = () => {
	const { auth } = useAuth();
	const [screenSize, setScreenSize] = useState(false);

	useEffect(() => {
		const handleContextmenu = (e) => {
			e.preventDefault();
		};
		document.addEventListener('contextmenu', handleContextmenu);
		return function cleanup() {
			document.removeEventListener('contextmenu', handleContextmenu);
		};
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setScreenSize(window.innerWidth < 1000);
		};

		handleResize();

		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const renderComponent = (DesktopComponent) => {
		return screenSize ? <ScreenSizeAlert /> : <DesktopComponent />;
	};

	return (
		<>
			<BrowserRouter>
				<UserNavigate />
				<FilterContext>
					<NProvider>
						<AuthContext>
							<Suspense fallback={<FallbackLoading />}>
								<Routes>
									<Route path='/' element={<Layout />}>
										<Route
											path='/'
											element={
												auth ? <Navigate to='/tools' /> : <LoginScreen />
											}
										/>
										<Route
											path='/signUp'
											element={
												auth ? (
													<Navigate to='/contactsearch' />
												) : (
													<SignUpScreen />
												)
											}
										/>
										<Route
											path='/email'
											element={auth ? <Navigate to='/profile' /> : <Verify />}
										/>
										<Route
											path='/forgotpassword'
											element={
												auth ? <Navigate to='/profile' /> : <ForgotPassword />
											}
										/>
										<Route
											path='/terms-conditions'
											element={<TermsConditions />}
										/>
										<Route
											path='/resetpassword/:id'
											element={<ResetPassword />}
										/>
										<Route
											path='/teamSignUp'
											element={
												auth ? <Navigate to='/profile' /> : <TeamSignUp />
											}
										/>
										<Route path='/thankyou' element={<SuccessScreen />} />
										<Route path='/failed' element={<FailedScreen />} />
										<Route path='/link' element={<LinkScreen />} />
										<Route path='/datasets' element={<Datasets />} />

										{/* Private Routes */}
										<Route element={<ProtectedRoutes />}>
											<Route path='/api-key' element={<AppLayout />} />
											<Route path='/overview' element={<AppLayout />} />
											<Route path='/single-process' element={<AppLayout />} />
											<Route path='/bulk-process' element={<AppLayout />} />
											<Route
												path='/integrate-vendors'
												element={<AppLayout />}
											/>
											<Route path='/b2b-data' element={<AppLayout />} />
											<Route path='/healthcare-data' element={<AppLayout />} />
											<Route path='/settings' element={<AppLayout />} />
											<Route path='/dashboard' element={<DashBoard />} />
											{/* <Route
											path='/contactsearch'
											element={renderComponent(ContactSearch)}
										/> */}
											{/* <Route path='/mylist' element={renderComponent(MyLists)} /> */}
											<Route
												path='/billing'
												element={renderComponent(BillingScreen)}
											/>
											<Route path='/datasearch' element={<DataSearch />} />
											<Route path='/api' element={<APIScreen />} />
											<Route
												path='/integrations'
												element={<IntegrationScreen />}
											/>
											<Route path='/plans' element={<AppLayout />} />
											<Route path='/tools' element={<MyTools />} />
											<Route path='/myprofile' element={<Profile />} />
											<Route path='*' element={<NotFound />} />
										</Route>
									</Route>
								</Routes>
							</Suspense>
						</AuthContext>
					</NProvider>
				</FilterContext>
			</BrowserRouter>
		</>
	);
};

export default AllRoutes;
